import { Injectable, inject } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { CommonSettingModel } from '../vo/common-setting.model';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';
import { CommonSetting } from 'src/app/commons/kymw00/common-setting';

/**
 * 環境設定(SETTING)を取得するサービス
 *
 * @export GetCommonSettingService
 * @class GetCommonSetting
 * @extends {PlessResponder}
 */
@Injectable()
export class GetCommonSettingService extends PlessJsonResponderSub<CommonSettingModel[]> {

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * API呼び出し
   *
   * @memberof GetCommonSettingService
   */
  execute(): void {
    this.send('KYMW02getCommonSetting', new PlessRequest());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetCommonSettingService
   */
  success(data: CommonSettingModel[]): void {
    CommonSetting.init(data);
  }

  /**
   * API通信失敗時の処理
   *
   * @param {string} status エラーステータス
   * @param {*} result エラー結果
   * @memberof GetCommonSettingService
   */
  exceptionError(status: string, result: any): void {
    super.exceptionError(status, result);
  }
}
